import React, { useEffect, useState } from "react";

import { Plus, Info, RightMinimalArrow } from "icons";
import { useParams } from "react-router-dom";

import cdesApi from "apis/cdeDefinitions";
import dataSourcesApi from "apis/dataSource";
import dsdeApi from "apis/dsde";
import {
  Accordion,
  SubHeader,
  Button,
  Typography,
  Tooltip,
} from "clearsense-ui/components";
import Container from "components/Common/Container";

import AnalyticsAndReports from "./AnalyticsAndReports";
import BusinessRules from "./BusinessRules";
import DataSourceDataElementMapping from "./DataSourceDataElementMapping";
import InterfaceDefinitions from "./InterfaceDefinitions";
import ReferenceSources from "./ReferenceSources";

const Dsde = () => {
  const [dataSource, setDataSource] = useState({});
  const [cde, setCde] = useState("");
  const [dsde, setDsde] = useState({});

  const { dataSourceId, cdeId } = useParams();

  const fetchDataSource = async () => {
    const { data } = await dataSourcesApi.get(dataSourceId);
    setDataSource(data);
  };

  const fetchCDE = async () => {
    try {
      const { data } = await cdesApi.getCde(cdeId);
      setCde(data);
    } catch (error) {
      logger.log(error);
    }
  };

  const fetchDsde = async () => {
    if (cde?.id && dataSource?.id) {
      const { data } = await dsdeApi.show({
        cde_definition_id: cdeId,
        data_source_id: dataSourceId,
      });
      setDsde(data?.dsde);
    }
  };

  useEffect(() => {
    fetchDataSource();
    fetchCDE();
  }, []);

  useEffect(() => {
    fetchDsde();
  }, [cde, dataSource]);

  const AccordionTitle = ({ title, tooltipText, description }) => (
    <div className="pl-6 w-full">
      <Typography
        style="h3"
        type="semibold"
        className="flex items-center gap-2"
      >
        {title}
        <Tooltip position="top" content={tooltipText}>
          <div>
            <Info size={15} />
          </div>
        </Tooltip>
      </Typography>
      <Typography type="regular">{description}</Typography>
    </div>
  );

  return (
    <Container className="p-4">
      <SubHeader
        breadcrumbs={[
          { label: "Data Sources", link: "/management/data-sources" },
          {
            label: dataSource?.name,
            link: location.pathname.split("/dsde")[0],
          },
          { label: `Mapping CDE: "${cde?.name}"`, link: "#" },
        ]}
        actionBlock={
          <Button
            label="View CDE Definition"
            style="secondary"
            icon={RightMinimalArrow}
            iconPosition="right"
          />
        }
      />
      <div>
        <Button
          style="secondary"
          label="Add Filter"
          icon={Plus}
          iconPosition="right"
          className="mt-4"
        />
      </div>
      <Accordion className="my-4" defaultActiveKey={0}>
        <Accordion.Item
          title={
            <AccordionTitle
              title="Data Source Data Element Mapping"
              tooltipText="This describes the context or description about the card as well the heading."
              description="This describes the actions to take on these cards"
            />
          }
        >
          <DataSourceDataElementMapping
            dataSource={dataSource}
            cde={cde}
            fetchDsde={fetchDsde}
            dsde={dsde}
          />
        </Accordion.Item>
        <Accordion.Item
          title={
            <AccordionTitle
              title="Interface Definitions"
              tooltipText="This describes the context or description about the card as well the heading."
              description="This describes the actions to take on these cards"
            />
          }
        >
          <InterfaceDefinitions />
        </Accordion.Item>
        <Accordion.Item
          isDisabled={dsde?.id ? false : true}
          tooltipContent={
            !dsde?.id
              ? "Please create DSDE to add reference source."
              : undefined
          }
          title={
            <AccordionTitle
              title="References Sources"
              tooltipText="This describes the context or description about the card as well the heading."
              description="This describes the actions to take on these cards"
            />
          }
        >
          {dsde?.id && (
            <ReferenceSources cde={cde} dataSource={dataSource} dsde={dsde} />
          )}
        </Accordion.Item>
        <Accordion.Item
          title={
            <AccordionTitle
              title="Business Rules"
              tooltipText="This describes the context or description about the card as well the heading."
              description="This describes the actions to take on these cards"
            />
          }
        >
          <BusinessRules />
        </Accordion.Item>
        <Accordion.Item
          title={
            <AccordionTitle
              title="Analytics and Reports"
              tooltipText="This describes the context or description about the card as well the heading."
              description="This describes the actions to take on these cards"
            />
          }
        >
          <AnalyticsAndReports />
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default Dsde;
